import { useSnackbar } from "@outschool/ui-components-shared";
import { useCallback } from "react";

const TOAST_DURATION_MS = 3000;

const TOAST_ANCHOR = { vertical: "bottom", horizontal: "right" } as const;

const TOAST_SX_BY_SEVERITY = {
  success: {
    backgroundColor: "#fff",
    color: "grey.900",
    border: "1px solid",
    borderColor: "grey.200",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
  },
  info: {
    backgroundColor: "#fff",
    color: "grey.900",
    border: "1px solid",
    borderColor: "primary.200",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
  },
  error: {
    backgroundColor: "error.main",
    color: "error.contrastText",
    border: "1px solid",
    borderColor: "error.600",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
  },
} as const;

type ToastSeverity = keyof typeof TOAST_SX_BY_SEVERITY;

export function useToast() {
  const { addSnackbarContent } = useSnackbar();

  return useCallback(
    (message: string, severity: ToastSeverity) => {
      addSnackbarContent(
        message,
        TOAST_DURATION_MS,
        severity,
        TOAST_ANCHOR,
        TOAST_SX_BY_SEVERITY[severity],
      );
    },
    [addSnackbarContent],
  );
}
